import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertWebEmailLinkCommand from './insertwebemaillinkcommand';

export default class InsertWebEmailLinkUI extends Plugin {

  init() {
    this.editor.commands.add('insertwebemaillink', new InsertWebEmailLinkCommand(this.editor));
  }
}